var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'height' : _vm.height }),attrs:{"id":"center-div"}},[_vm._m(0),_c('ExButton',{attrs:{"fullwidth":"hover","label":"Go Back","buttonWidth":"full","size":"small"},on:{"onClick":_vm.goBackHistory}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":require("@components/assets/pageNotFound.png"),"alt":"Page Not Found"}})])
}]

export { render, staticRenderFns }